import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { LEGAL_PAGES } from '../data/legalContent';
import { useTranslation } from '../hooks/useTranslation';

export default function LegalPage() {
  const { slug } = useParams();
  const { lang } = useTranslation();
  const page = (LEGAL_PAGES[lang] || LEGAL_PAGES.fr)[slug];

  if (!page) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-center">
        <div>
          <div className="font-serif text-3xl">Page introuvable</div>
          <Link to="/" className="text-gold text-xs tracking-luxury uppercase mt-6 inline-block">Retour à l'accueil</Link>
        </div>
      </div>
    );
  }

  return (
    <main data-testid="legal-page">
      <section className="pt-20 pb-12 lg:pt-28 lg:pb-16 bg-ivory text-center">
        <div className="max-w-3xl mx-auto px-4 animate-fade-up">
          <div className="text-[11px] tracking-luxury uppercase text-gold mb-4">MSK Watch</div>
          <h1 className="font-serif text-4xl md:text-6xl font-light" data-testid="legal-page-title">{page.title}</h1>
        </div>
      </section>

      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-4 lg:px-8 space-y-10">
          {page.sections.map((s, i) => (
            <div key={i} className="border-t border-[#EAE4D8] pt-8 first:border-t-0 first:pt-0">
              <h2 className="font-serif text-2xl md:text-3xl font-light mb-3">{s.h}</h2>
              <p className="text-[#555] leading-relaxed text-sm md:text-base">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
